import { render } from "./IssueChangeStateForm.vue?vue&type=template&id=396046d7"
import script from "./IssueChangeStateForm.vue?vue&type=script&lang=js"
export * from "./IssueChangeStateForm.vue?vue&type=script&lang=js"

import "./IssueChangeStateForm.vue?vue&type=style&index=0&id=396046d7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__